import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AdminRegisterUserToCourseRequest, studentCoursesApi } from "./studentCoursesApi";
import { QUERIES_KEYS } from "queries";

export const useAdminRegisterUserToCourse = (studentId: number) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: AdminRegisterUserToCourseRequest) => studentCoursesApi.register(studentId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERIES_KEYS.STUDENT_COURSES(studentId) });
    },
  });
};
